export function getFirstLocaleValue(localizedObj, fallback = "") {
  if (!localizedObj) return fallback;
  if (typeof localizedObj === "string") return localizedObj;
  return Object.values(localizedObj)[0] || fallback;
}

export function transformConsent(raw) {
  const questions = (raw.questions || []).map((q) => ({
    ...q,
    // accepted reflects the server-side answer state
    accepted: q.answer !== null ? q.answer?.accepted === true : undefined,
    // preserve full translation objects for title and description
    title: q.title || {},
    description: q.description || {},
  }));

  return {
    id: raw.id,
    // preserve full translation object for title
    title: raw.title || {},
    // keep name as fallback for backward compatibility (using first available locale)
    name: getFirstLocaleValue(raw.title, `Consent ${raw.id}`),
    // preserve full translation object for content
    content: raw.content || {},
    required: questions.some((q) => q.required),
    type: raw.type,
    // true if at least one question was already answered server-side
    answered: questions.some((q) => q.answer !== null),
    questions,
    filesUrls: raw.filesUrls || {},
  };
}

export function transformConsents(responseData) {
  const list =
    responseData?.data && Array.isArray(responseData.data)
      ? responseData.data
      : Array.isArray(responseData)
      ? responseData
      : [];

  return list.map(transformConsent);
}
